import { Alert } from '@mui/material';
import { PropsWithChildren, useEffect, useRef } from 'react';
import { Loader } from './components/Loader/Loader';
import { useInitApp } from './hooks/useInitApp';
import { FormulaFieldsFlagSync } from './services/state/AdminPanel/FormulaFieldsFlagSync';
import { endAppLoadSpan } from './sentry-init';
import { LoadingStatus } from './types';

export function AppLoader({ children }: PropsWithChildren) {
  const loadStatus = useInitApp();
  const spanEndedRef = useRef(false);

  useEffect(() => {
    if (loadStatus.overallStatus === LoadingStatus.success && !spanEndedRef.current) {
      spanEndedRef.current = true;
      endAppLoadSpan();
    }
  }, [loadStatus.overallStatus]);

  if (loadStatus.overallStatus == LoadingStatus.error) {
    return <Alert severity='error'>Application Error occurred</Alert>;
  }

  if (loadStatus.overallStatus !== LoadingStatus.success) {
    return <Loader height='90vh' />;
  }

  return (
    <>
      <FormulaFieldsFlagSync />
      {children}
    </>
  );
}
